import thunkMiddleware from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';

import { profile } from './profile/reducers';
import { tasks } from './tasks/reducers';
import { myTask } from './myTask/reducers';
import { mathTest } from './mathTest/reducers';
import { subjectTest } from './subjectTest/reducers';
import { languageTest } from './languageTest/reducers';
import { test } from './test/reducers';

const rootReducer = combineReducers({
  profile,
  test,
  tasks,
  myTask,
  mathTest,
  subjectTest,
  languageTest,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = preloadedState => createStore(
  rootReducer,
  preloadedState,
  composeEnhancers(applyMiddleware(thunkMiddleware)),
);

// let testState = {};
// const saveTestStore = state => {
//   if (testState === state.test) {
//     return;
//   }
//   testState = state.test;
//   try {
//     const serializedState = JSON.stringify(testState);
//     localStorage.setItem('testState', serializedState);
//   } catch (err) { }
// };
// const loadTestState = () => {
//   try {
//     const serializedState = localStorage.getItem('testState');
//     if (!serializedState) {
//       return null;
//     }
//     return JSON.parse(serializedState);
//   } catch (e) {
//     return null;
//   }
// };

const getStore = () => {
  const preloadedState = {};
  // const loadedTestState = loadTestState();
  // if (loadedTestState) {
  //   preloadedState.test = loadedTestState;
  // }
  const store = configureStore(preloadedState);
  // store.subscribe(() => {
  //   const state = store.getState();
  //   saveTestStore(state);
  // });
  return store;
}

export default getStore;



// WEBPACK FOOTER //
// ./src/store/index.js